<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="left_nav">
        <div @click="navCall = item.num" :class="item.num===navCall?'navSelected':''"
             v-for="item in NavList"
             :key="item.num">
          {{ item.title }}
        </div>
      </div>
      <div class="form_wrap">
        <div class="toolsIntroduce">
          <div class="left">
            <img src="../img/face.png" alt="">
          </div>
          <div class="right">
            <p>
              功能介绍
            </p>
            <span style="display: block">
              全新 AI 视频 Luma 重磅上线，生成效果大幅度的提升，视频质量更高清
            </span>
          </div>
        </div>
        <div class="options_item" v-if="navCall===2">
          <div class="item_title" flex-align>
            <div class="text">上传参考图（必填）</div>
          </div>
          <div class="Reference_image">
            <el-upload :http-request="$projectUpload"
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/aivideo/upload/?soft=1'"
                :show-file-list="false"
                accept=".jpg,.png"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                multiple>
              <div v-if="create_form.img_url" class="yesUpload">
                <img :src="cdn_url_replace(create_form.img_url)" alt="" class="yesUpload_img">
                <div class="yesUpload_icon" @click.stop="create_form.img_url=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过10MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">视频描述</div>
          </div>
          <div class="btm_area_con">
            <div>
                <textarea class="text" rows="4" v-model="create_form.desc"
                          placeholder="输入视频描述词，描述词越详细生成的视频效果更佳~"></textarea>
            </div>
            <div class="depict_switch">
              <div class="switch">
                <el-switch
                    style="zoom: 0.7"
                    @change="getPromptData4()"
                    active-value="1"
                    inactive-value="0"
                    active-color="#5865f2"
                    inactive-color="#53555f"
                    v-model="auto_spell">
                </el-switch>
                <span style="margin-left: 4px;font-size: 12px">一键优化描述词</span>
              </div>
              <div class="empty" @click="create_form.desc">清空</div>
            </div>
          </div>
        </div>
        <!-- <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">视频清晰度</div>
          </div>
          <div class="model_list">
            <div class="quality">
              <div @click="selectDefinition(du)"
                   v-for="(du,index) in definition"
                   :class="create_form.is_hd==du.value?'quality_btns':'quality_btn'">
                {{ du.name }}
              </div>
            </div>
          </div>
        </div> -->
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">视频时长</div>
          </div>
          <div class="model_list">
            <div class="quality">
              <div @click="create_form.duration =du.value "
                   v-for="(du,index) in duration_list"
                   :class="create_form.duration==du.value?'quality_btns':'quality_btn'">
                {{ du.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom_area" flex-center>
      <div :class="['primary_button', { 'disabled_btn': create_form.mode =='Sora' }]"
           :style=" create_form.mode =='Sora'?'pointer-events: none;':'pointer-events: ;'"
            @click="sendMsg" v-loading="sending">提交任务
        <span class="fz12" v-if="create_form.mode != 'Sora'">（消耗{{scoreCode}}积分）</span>
      </div>
    </div> -->
          <div class="newSubList">
      <div class="newSumit newSumitOthers" v-show="create_form.mode == 'Sora'">
        敬请期待
      </div>
      <div class="newSumit" @click="sendMsg" v-show="create_form.mode != 'Sora'">
        生成标清 
        <div class="subText">（消耗{{ scoreCode }}积分）</div>
        
      </div>
        <div class="newSumit newSumitOther" @click="create_form.is_hd=1,sendMsg()" v-show="create_form.mode != 'Sora'">
          生成高清
        <div class="subText">（消耗{{ newscoreCode }}积分）</div>

          <!-- <img src="./img/img_icon_02.gif" class="subImg" alt=""> -->
          <img src="./img/img_icon_hot01.gif" class="subImg" alt="">
        </div>
      </div>
    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
import AliCdn from '../../utils/ali_cdn'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      scoreCode: 25,
      newscoreCode:50,
      isTips:false,
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      create_form: {
        create_type: 1,
        img_url: "",//普通
        desc: "",
        auto_optimize: false,
        style: 0,
        size: '1:1',
        duration: 5,
        soft: 4,
        aspect_ratio: 6,
        mode: 'gen3a',
        img_urls: "",//以图片作为结尾帧
        seconds: 5,// 默认视频时长
        exploreMode: false, //true探索模式 false积分模式
        is_hd: 0,// 清晰度
      },
      sending: false,
      navCall: 1,
      NavList: [
        {title: '文生视频', num: 1,},
        {title: '图生视频', num: 2,},
      ],
      fileApi: FILE_API_SERVER,
      frame: false,
      fileAPI: API_SERVER,
      imgDialogVisible: false,
      model_desc: '',
      platform_list: [
        {name: "Runway3", name2: "gen3a", need_vip: 1, desc: 'Runway Gen 3 影视级动画特效，生成效果较好', platform: 1},
      ],
      duration_list: [
        {name: '5秒', need_vip: 1, value: 5},
      ],
      style_list: [
        {type: 1, name: "真实", id: 0},
        {type: 2, name: "动漫", id: 4},
        {type: 3, name: "卡通", id: 6},
      ],
      exploreMode_list: [
        {value: true, name: "排队",},
        {value: false, name: "不排队",},
      ],
      aspect_list: [
        // {type: '3:2', img: require('./img/16^9.png'), id: 6},

      ],
      video_list: [],
      noMore: false,
      loading: false,
      page: 1,
      intervalId: null,
      rec_img_list: [
        {
          name: '欧美女神',
          img_url: 'http://gips3.baidu.com/it/u=3886271102,3123389489&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960'
        },
        {
          name: '女生写真',
          img_url: 'http://gips1.baidu.com/it/u=1746086795,2510875842&fm=3028&app=3028&f=JPEG&fmt=auto?w=1024&h=1024'
        }, {
          name: '守望星空',
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/03.webp'
        }, {
          name: "皮克斯风",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/04.jpg'
        }, {
          name: "日漫女生",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/05.jpg'
        }, {
          name: "女生跳舞",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/06.jpg'
        }, {
          name: "孤独侠客",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/07.webp'
        }, {
          name: "美女骑行",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/08.webp'
        }, {
          name: "丛林狐狸",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/09.webp'
        }, {
          name: "饥饿雄狮",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/10.webp'
        }, {
          name: "旋转场景",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/11.webp'
        }, {
          name: "沙漠蜥蜴",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/12.webp'
        }
      ],
      select_rec_img: {
        img_url: ''
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      success_icon: true,
      definition: [
        {name: '标清', value: 0},
        {name: '高清', value: 1},
      ],
      perIncan: false, // ai提示词是否返回
      auto_spell: '1', // ai提示词是否关闭
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {

  },
  methods: {
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      return url.replace(o_url, c_url)
    },
    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    //发送消息
    sendMsg() {

      if (!this.checkLogin()) {
        return false
      }
      if(!utils.setOptData(this.userInfo,'btn_luma_create')){
          return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      if (this.create_form.desc === "") {
        this.$message.warning('请输入文字信息')
        return
      }
      if(this.create_form.desc.length>2000){
          this.$message.warning('描述信息不能超过2000字符')
          return
      }
      if (this.navCall === 1) {
        this.create_form.img_url = ""
      }
      if (this.navCall === 2) {
        if (this.create_form.img_url == '') {
          this.$message.warning('请上传图片')
          return;
        }
      }
      if (this.create_form.mode == 'Sora') {
        this.$message.warning('敬请期待')
        return;
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
            if(!this.create_form.is_hd&&!this.isTips){
        this.$confirm('标清生成质量稍差，90%用户选择高清生成，是否切换为高清生成？','提示',{
          confirmButtonText: '高清生成',
          cancelButtonText: '标清生成',
          type: 'warning'
        }).then(()=>{
          this.create_form.is_hd = 1
          this.sendMsg()
        }).catch(()=>{
          this.create_form.is_hd = 0
          this.isTips = true
          this.sendMsg()
        })
        return false
      }
      if (this.auto_spell > 0) {
        console.log('ai提示词')
        if (!this.perIncan) {
          this.$store.commit('setisInputVal', this.create_form.desc)
          this.$store.commit('setisInputtype', 'Stable Diffusion')
          this.$store.commit('setisInputValshow', true)
          return;
        }
      }

      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc
      this.create_form.seconds = this.create_form.duration
      this.create_form.is_optimize = this.create_form.auto_optimize
      // this.sendLoading = true
      // return
      this.submitQuestion(this.create_form);

    },
    submitQuestion(data, parent_msg_code, i) {
      this.sending = true;
      this.perIncan = false
      console.log(data)
      // return
      // 提交问题
      // data.source = "pc";
      this.$http.post('/front/aivideo/', data).then((res) => {
      this.create_form.is_hd = 0,
      this.isTips = false
        if (res.status == 200) {
          this.getProfile()
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "expired_gift_score") {
            // 队列已满
            this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          }else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      if(res.data.error !== ''){
        this.$message.error(res.data.error)
      }
      if (res.status == '200') {
        this.create_form.img_url = res.data.file_full_url
      }
    },
    beforeAvatarUpload(rawFile) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      const isIMG = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png';
      const isLt10M = rawFile.size / 1024 / 1024 < 10;
      const isSole = true

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(rawFile);
        img.onload = () => {
        let wS = img.width/img.height
        let hS = img.height/img.width
          if (!isIMG) {
            reject({isIMG:false})
            this.$message.error('上传图片只能是 JPG/PNG 格式!');
            return
          }
          if (!isLt10M) {
            reject({isLt10M:false})
            this.$message.error('上传图片大小不能超过 10MB!');
            return
          }
          if((wS>=0.4&&wS<=2.5)||(hS>=0.4&&hS<=2.5)){
            if(img.width<=500||img.height<=500){
              reject({isSole:false})
                // this.$message.error('图片大小需要大于500小于4090');
                this.$message({
                    message: '图片大小需要大于500小于4090',
                    type: 'warning'
                })
                return false
            }
            if(img.width>=4090||img.height>=4090){
                reject({isSole:false})
                // this.$message.error('图片大小需要大于500小于4090');
                this.$message({
                    message: '图片大小需要大于500小于4090',
                    type: 'warning'
                })
                return false
            }
          }else{
            reject({isSole:false})
            this.$message({
                message: '图片宽高比需在5:2或2:5之内',
                type: 'warning'
            })
            return false
          }
          resolve({ isIMG, isLt10M, isSole});
        }
      })
    },
    selectDefinition(model, index) {
      console.log(model.value)
      this.create_form.is_hd = model.value
      this.setScore()
    },
    setScore() {

      if(this.navCall == 1){
        console.log('文生视频')
        if (this.create_form.is_hd == 0) {
          this.scoreCode = 25
        } else if (this.create_form.is_hd == 1) {
          this.scoreCode = 50
        }
      }else{
        console.log('图省事视频')
        if ( this.create_form.is_hd == 0) {
          this.scoreCode = 25
        } else if (this.create_form.is_hd == 1) {
          this.scoreCode = 50
        }

      }

    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
  },
  watch: {
    '$store.state.isInputValshow'(newVal) {
      console.log('isInputValshow 变化:', newVal);
      if (!newVal) {
        if (this.isInputtype.length > 0) {
          this.perIncan = true
          this.create_form.desc = this.isInputVal
          this.sendMsg()
        }
      }
    },
  },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;
    .left_nav {
      margin: 10px 20px;
      padding: 4px 0;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #36373d;
      display: flex;
      align-items: center;
      color: #fff;
      background-color: #313338;

      div {
        flex: 1;
        text-align: center;
        margin: 0 4px;
        cursor: pointer;
      }

      .navSelected {
        background-color: #5865f2;
        border-radius: 4px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 60px;
      height: 100%;
      .toolsIntroduce {
        background-color: #1e1f22;
        padding: 16px 14px;
        display: flex;
        border-radius: 5px;
        box-sizing: border-box;
        overflow: hidden;

        .left {
          width: 20px;
          margin-right: 12px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .right {
          width: calc(100% - 32px);
          flex-grow: 1;
          word-wrap: break-word;

          p {
            font-size: 14px;
            font-weight: 700;
            height: 20px;
            margin-bottom: 5px;
          }

          span {
            font-size: 12px;
            word-wrap: break-word;
            white-space: normal;
          }

        }
      }

      // 绘画描述
      .btm_area_con {
        //position: relative;
        border-radius: 5px;
        border: 2px solid #5865f2;
        padding: 10px 10px;

        .text {
          width: 100%;
          background-color: #2b2d31;
          border: 0;
          color: #b4b9bf;
          font-size: 14px;
          letter-spacing: 1.5px;
          line-height: 20px;
        }

        .depict_switch {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          margin-top: 10px;

          .switch {
            display: flex;
            align-items: center;

            span {
              margin-left: 10px;
            }
          }

          .empty {
            color: #b4b9bf;
            cursor: pointer;
          }

          .empty:hover {
            color: #fff;
          }
        }
      }
      // 模型选择
      .model_list {
        display: flex;


        .model_item {
          border-radius: 6px;
          border: 2px solid #1d2027;
          position: relative;
          overflow: hidden;

          &.active {
            border-color: #5865f2;
          }

          img {
            border: none;
            width: 100%;
          }

          .model_title {
            position: absolute;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.73);
            height: 25px;
            font-size: 12px;
            left: 0;
            bottom: 0;
          }
        }

        .quality {
          display: flex;
          color: #fff;
          font-size: 14px;

          .quality_btn {
            border: 2px solid #393c43;
            border-radius: 3px;
            background-color: #1d2027;
            padding: 10px 35px;
            margin: 0 20px 0 0;
            cursor: pointer;
          }

          .quality_btns {
            border: 2px solid #5865f2;
            border-radius: 3px;
            background-color: #303245;
            padding: 10px 35px;
            margin: 0 20px 0 0;
            cursor: pointer;
          }

        }

      }
      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }

    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }
  }

//提交按钮
  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;
      /deep/ .el-loading-mask {
        background: none;
      }

      &.disabled_btn {
        cursor: not-allowed;
        background-color: #393b3f;
        user-select: none;
        color: #999;
      }
    }

  }
        .newSubList{
      width: 100%;
      height: 90px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      // justify-content: space-around;
      justify-content: space-between;
      //border-top: 1px solid #42464e;
      padding: 0 15px;
    .newSumit{
      flex-shrink: 0;
      width: 122px;
      height: 55px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #5865f2;
      // text-align: center;
      border-radius: 10px;
      // padding: 0 10px;
      cursor: pointer;
      font-size: 14px;
      // line-height: 19px;
      .subText{
        font-size: 10px;
      }
    }
    .newSumitOther{
      // margin-left: 20px;
      width: 198px;
      position: relative;
      background: linear-gradient(to right,#fd7a57,#fe3f40);
      .subImg{
        position: absolute;
        right: 52px;
        top: 0px;
      }
    }
    .newSumitOthers{
      width: 90%;
      margin: 0 auto;
      background: #393b3f;
      color: #999;
      cursor: no-drop;
    }
    }


}




/deep/ .el-loading-mask {
  background: none;
}
</style>